export type UploadMediaType = 'image/jpeg'|'image/png'|'image/webp'|'image/heic'|'image/heif';
export const PHOTO_ACCEPT='image/jpeg,image/png,image/webp,image/heic,image/heif,image/x-heic,image/x-heif,.jpg,.jpeg,.png,.webp,.heic,.heif';
export const PHOTO_FILE_ERROR='Выберите JPEG, PNG, WebP, HEIC или HEIF размером до 5 МБ.';
/** Filename is a fallback only for absent/generic MIME; server decodes real bytes. */
export function uploadMediaType(file: Pick<File,'name'|'type'|'size'>):UploadMediaType|null {
 if(file.size<=0||file.size>5*1024*1024)return null;
 const type=file.type.toLowerCase().trim().split(';')[0]?.trim()??'';
 const known:Record<string,UploadMediaType>={'image/jpeg':'image/jpeg','image/png':'image/png','image/webp':'image/webp','image/heic':'image/heic','image/heif':'image/heif','image/x-heic':'image/heic','image/x-heif':'image/heif'};
 if(known[type])return known[type];
 if(type!==''&&type!=='application/octet-stream')return null;
 const extension=file.name.split('.').pop()?.toLowerCase()??'';
 return ({jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png',webp:'image/webp',heic:'image/heic',heif:'image/heif'} as Record<string,UploadMediaType>)[extension]??null;
}
export async function readPhotoFile(file:File){
 const mediaType=uploadMediaType(file);if(!mediaType)throw new Error(PHOTO_FILE_ERROR);
 const url=await new Promise<string>((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result));reader.onerror=()=>reject(new Error('Не удалось открыть фото.'));reader.readAsDataURL(file);});
 const base64=url.slice(url.indexOf(',')+1);
 return {url:`data:${mediaType};base64,${base64}`,base64,mediaType};
}
